import React from "react";
import { NavLink } from "react-router-dom";
import { useLanguage } from "hooks";
import { Icons } from "components";

export default function FloatingActions({ reachedFooter }) {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";

  return (
    <div className={`floating_actions ${reachedFooter && "slideout"}`}>
      {/* <a
        target="_blank"
        rel="noreferrer"
        href="https://login.shoman.org/?Page=Login&v=5.21.11.14.1&Service=overdrive&ReturnURL=https:%2F%2Fauth.overdrive.com%2Fv2%2Fexternal%2Foauth%2Fcallback&state=CfDJ8MCnufYcWWtPjWC7CMZm-BwHT47HdFLnKrX4B2F5RT8prk3Xo57l062mOqvJl2O6wcCu3aQZiuUbn8Bjrg93fXGk_4FY_6xJQN34cU8_EGD5xWZhNbl1agUHbtj09I12mQ7qyfUJWoq4e-Wq4aZkk-gw8wZGGJg5xiId0WJsh54ytVu4aYLc9AL9JK6EsZEPSetM25J4Wfo519uQV7KYZ3r-_uosYdV77ZUf9bxCSJI5bUyaMHI4jeHaM-aT3FOmpr3Mgx1spxf6NuvYAp7sAnWBUuvu8AZgP42KWmesTP7fJdntQ0XASFAldQtUEMYPBc0_M4o7tPnjXlCdfgy2tRuFnf81lTM-67ZZmCJKIh5sVQPfEAX7Mq4oxC8MSCN6qP56A_EyvLJhn03QvPg-226Vv2n1q47ZuohUvVIl-yuQI4AJi6vsP7A0s9_pM3qdj7AKEfFdJkEGvTKGyx7o1y-bKRuDxkXclt1cE6MEuR2dqrSMlvFOEz3Hu0GSBDmSGW3oxabvtOTC4b45Z_7jHRebDAryenV5icwkTQpPQH0qCiP4fJInQ2-B3OdkGKS4T86qEubOaWo7Ioot98OGsVgv8IDK8EqnKSCI5nvxMFdrboaP9Y3SFTaint3CdO8b5yp-Px_AxNAtQjpjJiOiI-ATizYP0aVg6LWz8HNa8eM7D_vGt_ldJDceexwgA9Nd6aXlHQrV8eqqMDQ9lE6WVVSd1qUiIzm5wSPWW1q94bSK5b6VCtJtKKOc2chTl1TWzaBYno-b3D61jN7P0MKYBS6S7oxGI4lEgIVLsl82PFvegqjYrC5zv34kLUhHZwKeEroXwSFnywH0pwy3IDrpMufH0OyOo-Fa42jjvkjZh8q-"
        className="floating_button p-0 d-flex justify-content-center align-items-center shadow-lg rounded-circle mb-1 mb-lg-2"
      >
        <img className="rounded-circle w-100" src="/logo.png" alt="" />
        <p className="slide_text d-none d-lg-flex fw-bold">
          مؤسسة عبد الحميد شومان
        </p>
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://search.ebscohost.com/"
        className="floating_button p-0 d-flex justify-content-center align-items-center shadow-lg rounded-circle mb-1 mb-lg-2"
      >
        <img className="rounded-circle w-100" src="/E2.png" alt="" />
        <p className="slide_text d-none d-lg-flex fw-bold">Ebscohost</p>
      </a> */}
      <NavLink
        to="/search"
        className="floating_button p-2 d-flex justify-content-center align-items-center shadow-lg bg-secondary rounded-circle mb-1 mb-lg-2"
      >
        <Icons.Search />
        <p className="slide_text d-none d-lg-flex fw-bold">
          {language.searchLibrary}
        </p>
      </NavLink>
      <NavLink
        to="/contact"
        className="floating_button p-2 d-flex justify-content-center align-items-center shadow-lg bg-primary rounded-circle"
      >
        <Icons.Chat />
        <p className="slide_text d-none d-lg-flex fw-bold">{language.help}</p>
      </NavLink>
    </div>
  );
}
